(function(){
  var root=document.getElementById('cs-drawer');if(!root||root.dataset.ready)return;root.dataset.ready='1';
  var D=JSON.parse(document.getElementById('cs-drawer-data').textContent);
  var R=D.root.replace(/\/$/,'')+'/';

  /* Clean fetch from a blank iframe so cart-app scripts that wrap window.fetch don't react to our requests. */
  var nf=window.fetch.bind(window);
  try{var fr=document.createElement('iframe');fr.style.display='none';fr.setAttribute('aria-hidden','true');document.documentElement.appendChild(fr);if(fr.contentWindow&&fr.contentWindow.fetch)nf=fr.contentWindow.fetch.bind(fr.contentWindow);}catch(e){}
  function api(path,body){return nf(R+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:body?JSON.stringify(body):undefined}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});});}

  function money(c){
    var f=D.moneyFormat||'£{{amount}}';c=Number(c)||0;
    function fmt(n,d,ts,ds){var s=(n/100).toFixed(d).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return s[0]+(s[1]?ds+s[1]:'');}
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
      if(k==='amount_no_decimals')return fmt(c,0,',','.');
      if(k==='amount_with_comma_separator')return fmt(c,2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator')return fmt(c,0,'.',',');
      return fmt(c,2,',','.');});
  }
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function q(s){return root.querySelector(s);}

  function eta(){
    function add(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);if(d.getDay()%6)n--;}return d;}
    var o={day:'numeric',month:'short'};var now=new Date();
    return add(now,6).toLocaleDateString('en-GB',o)+' – '+add(now,10).toLocaleDateString('en-GB',o);
  }

  function open(){root.classList.add('is-open');root.setAttribute('aria-hidden','false');document.documentElement.classList.add('csd-lock');}
  function close(){root.classList.remove('is-open');root.setAttribute('aria-hidden','true');document.documentElement.classList.remove('csd-lock');}
  root.addEventListener('click',function(e){if(e.target.closest('[data-csd-close]'))close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

  function syncHeader(cart){
    document.querySelectorAll('cart-count').forEach(function(el){el.textContent=cart.item_count;});
    document.querySelectorAll('cart-dot').forEach(function(el){el.classList.toggle('is-visible',cart.item_count>0);});
  }

  function render(cart){
    syncHeader(cart);
    q('[data-csd-count]').textContent=cart.item_count?'('+cart.item_count+')':'';
    var list=q('[data-csd-items]'),empty=q('[data-csd-empty]'),foot=q('[data-csd-foot]');
    empty.hidden=cart.item_count>0;foot.style.display=cart.item_count?'':'none';
    var save=0,html='';
    cart.items.forEach(function(it,i){
      var v=D.variants.filter(function(x){return x.id===it.variant_id;})[0];
      var cmp=v&&v.compare>v.price?v.compare*it.quantity:0;
      if(cmp)save+=cmp-it.final_line_price;
      var img=it.image?it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=160':'';
      html+='<div class="csd__item">'+(img?'<img src="'+esc(img)+'" alt="">':'<span></span>')+
        '<div><p class="csd__iname">'+esc(it.product_title)+'</p>'+
        (it.variant_title?'<p class="csd__ivar">'+esc(it.variant_title)+'</p>':'')+
        '<div class="csd__qty"><button type="button" data-line="'+(i+1)+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease">−</button><span>'+it.quantity+'</span><button type="button" data-line="'+(i+1)+'" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div></div>'+
        '<div class="csd__iprice">'+money(it.final_line_price)+(cmp?'<s>'+money(cmp)+'</s>':'')+
        '<button type="button" class="csd__rm" data-line="'+(i+1)+'" data-q="0">Remove</button></div></div>';
    });
    list.innerHTML=html;
    save+=cart.total_discount||0;
    q('[data-csd-save]').hidden=!(save>0);q('[data-csd-save-amt]').textContent=money(save);
    q('[data-csd-total]').textContent=money(cart.total_price);
    q('[data-csd-eta]').textContent=eta();

    /* Bundle upgrade nudge */
    var nudge=q('[data-csd-nudge]');nudge.hidden=true;
    var line=-1,cur=null;
    cart.items.forEach(function(it,i){D.variants.forEach(function(v,vi){if(v.id===it.variant_id&&it.quantity===1&&line<0){line=i;cur=vi;}});});
    if(line>=0&&cur<D.variants.length-1){
      var a=D.variants[cur],b=D.variants[cur+1];
      if(b.available){
        var more=b.price-a.price,saveB=b.compare>b.price?b.compare-b.price:0;
        nudge.innerHTML='<p>Upgrade to <strong>'+esc(b.title.replace(/Bottle$/,'Bottles'))+'</strong> for just <strong>'+money(more)+'</strong> more'+(saveB?' and save <strong>'+money(saveB)+'</strong> in total':'')+'.</p><button type="button" data-upgrade="'+(line+1)+'" data-to="'+b.id+'">Upgrade</button>';
        nudge.hidden=false;
      }
    }

    /* Hide add-on if already in cart */
    var up=q('[data-csd-upsell]');
    if(up){var h=up.getAttribute('data-handle');up.hidden=cart.items.some(function(it){return it.handle===h;});}
  }

  function refresh(){return api('cart.js').then(render);}
  function busy(b){root.classList.toggle('is-busy',b);}

  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-line]');
    if(b){busy(true);api('cart/change.js',{line:+b.dataset.line,quantity:Math.max(0,+b.dataset.q)}).then(render).finally(function(){busy(false);});return;}
    var u=e.target.closest('[data-upgrade]');
    if(u){busy(true);api('cart/change.js',{line:+u.dataset.upgrade,quantity:0}).then(function(){return api('cart/add.js',{items:[{id:+u.dataset.to,quantity:1}]});}).then(refresh).finally(function(){busy(false);});return;}
    var a=e.target.closest('[data-csd-add]');
    if(a){busy(true);api('cart/add.js',{items:[{id:+a.dataset.csdAdd,quantity:1}]}).then(refresh).finally(function(){busy(false);});}
  });

  function currentVariant(form){
    var c=document.querySelector('.cs-bundle__card.is-active[data-variant]');
    if(c)return +c.dataset.variant;
    var p=new URLSearchParams(location.search).get('variant');if(p)return +p;
    var i=form.querySelector('input[name="id"]');return i?+i.value:(D.variants[0]&&D.variants[0].id);
  }

  /* Take over add-to-cart on this page (capture phase runs before the theme/app handlers). */
  window.addEventListener('submit',function(e){
    var f=e.target;if(!f||!f.action||f.action.indexOf('/cart/add')===-1)return;
    e.preventDefault();e.stopImmediatePropagation();
    var btn=f.querySelector('[type="submit"]')||document.querySelector('button[form="'+f.id+'"][type="submit"]');
    if(btn){btn.setAttribute('aria-busy','true');btn.disabled=true;}
    var id=currentVariant(f);
    api('cart/add.js',{items:[{id:id,quantity:1}]}).then(refresh).then(open).catch(function(err){alert((err&&err.description)||'Sorry, this item could not be added.');}).finally(function(){if(btn){btn.removeAttribute('aria-busy');btn.disabled=false;}});
  },true);

  /* Header cart icon opens this drawer on this page. */
  document.addEventListener('click',function(e){
    var l=e.target.closest('.header__cart-link a, a[href$="/cart"][aria-controls="cart-drawer"]');
    if(!l)return;e.preventDefault();e.stopImmediatePropagation();refresh().then(open);
  },true);

  refresh();
})();